module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }, [(_vm.banks) ? [(_vm.placeholder) ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.banks), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.id,
        "selected": _vm.value == bank.id
      }
    }, [_vm._v(_vm._s(bank.bank_code) + " - " + _vm._s(bank.name))])
  })] : _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Carregando bancos...")])], 2), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9e6e7e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputBanks.vue
// module id = 1048
// module chunks = 34